import {
  columnConsolidatedResource,
  columnName,
  columnResource,
  columnRole,
  columnSecondaryResource,
  columnWhat,
  columnWhen,
} from '@/constants/fields';

const resolveAuditPermission = (category, permissions) => ({
  all: permissions.audit.read,
  cohort: permissions.cohorts.audit,
  collection: permissions.collections.audit,
  dataset: permissions.datasets.audit,
  request: permissions.requests.audit,
  role: permissions.roles.audit,
  search: permissions.search.audit,
  user: permissions.users.audit,
  usergroup: permissions.usergroups.audit,
}[category]);

const allowAuditRead = (category, { permissions }, isCurrentUser = false) => (
  resolveAuditPermission(category, permissions) || (category === 'user' && isCurrentUser)
);

export const allowResourceLink = (
  entity,
  allowRoleLink,
  allowUserLink,
  allowDatasetLink,
  allowSearchLink,
  allowRequestLink,
  allowCohortLink,
  allowCollectionLink,
  allowUserGroupLink,
) => ({
  collection: allowCollectionLink,
  cohort: allowCohortLink,
  dataset: allowDatasetLink,
  request: allowRequestLink,
  role: allowRoleLink,
  search: allowSearchLink,
  user: allowUserLink,
  usergroup: allowUserGroupLink,
}[entity]);

export const buildColumns = (category) => ({
  all: [columnWhen, columnName, columnRole, columnWhat, columnResource],
  collection: [columnWhen, columnName, columnWhat, columnSecondaryResource],
  dataset: [columnWhen, columnName, columnWhat, columnConsolidatedResource],
  request: [columnWhen, columnName, columnWhat, columnSecondaryResource],
  role: [columnWhen, columnName, columnWhat, columnConsolidatedResource],
  user: [columnWhen, columnName, columnWhat, columnResource],
  usergroup: [columnWhen, columnName, columnWhat, columnResource],
}[category] || [columnWhen, columnName, columnWhat]);

export default allowAuditRead;
